// extracted by mini-css-extract-plugin
export default {"section":"styles_section__II4hO","slider":"styles_slider__w8te9"};